import React from 'react'
import { Alert, Button, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import VerifyEmailAlert from './VerifyEmailAlert'

/**
 * Email verification code entry modal. Restores the pre-redesign content:
 * the intro line telling the user where the code was sent, a dismissible
 * invalid-code alert, and the charity-flow message (VerifyEmailAlert).
 */
export default function EmailVerifyModal({
  show,
  onHide,
  email,
  error,
  onDismissError,
  code,
  setCode,
  onVerify,
}) {
  const { t } = useTranslation()

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('users.edit.email_verify_title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>{t('users.edit.email_verify_message', { email })}</div>
        <br />
        {error && (
          <Alert variant="danger" onClose={onDismissError} dismissible>
            <p>{t('users.edit.email_verify_error_alert')}</p>
          </Alert>
        )}
        <VerifyEmailAlert />
        <label htmlFor="emailVerificationCode" className="visually-hidden">
          {t('users.edit.email_verify_placeholder')}
        </label>
        <input
          className="form-control"
          id="emailVerificationCode"
          name="emailVerificationCode"
          inputMode="numeric"
          type="text"
          value={code}
          onChange={e => setCode(e.target.value)}
          placeholder={t('users.edit.email_verify_placeholder')}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('event.delete_modal_cancel')}
        </Button>
        <Button variant="primary" onClick={onVerify}>
          {t('users.edit.email_verify')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

EmailVerifyModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  email: PropTypes.string,
  error: PropTypes.bool,
  onDismissError: PropTypes.func.isRequired,
  code: PropTypes.string,
  setCode: PropTypes.func.isRequired,
  onVerify: PropTypes.func.isRequired,
}
